import { convertUtcToUae, formatDateToDDMMYYYY } from "@utils/date-time";

const EMPTY = "-";

/** Every date and time of the detail page is shown in UAE time, like the nomination grid. */
export const formatUaeDateTime = (iso?: string | null) =>
  iso ? formatDateToDDMMYYYY(convertUtcToUae(iso), true) : EMPTY;

export const formatUaeDate = (iso?: string | null) =>
  iso ? formatDateToDDMMYYYY(convertUtcToUae(iso)) : EMPTY;
